import KatalMetricsPublisher from "@amzn/katal-metrics/lib/KatalMetricsPublisher";
import ValidateSimpleString from "@amzn/katal-metrics/lib/helper/ValidateSimpleString";
import metricsDriverFactory from "./metricsDriverFactory";
import metricsPublisherFactory from "./metricsPublisherFactory";
import { MetricsState } from "./metricsSlice";

/**
 * React hook that returns an action publisher for a given redux state and method name.
 *
 * @param {MetricsState} metricsState
 * @param {string} componentOrMethodName
 * @returns
 */
const useMetricsPublisher = (
  metricsState: MetricsState,
  componentOrMethodName: string
): KatalMetricsPublisher => {
  try {
    ValidateSimpleString(componentOrMethodName, "componentOrMethodName");
  } catch (error) {
    console.error(`Invalid name: ${componentOrMethodName}`);
    console.error(error);
  }

  // Use state to get config.
  const publisher = metricsPublisherFactory(
    metricsDriverFactory(metricsState.config.isProduction),
    metricsState
  );
  return publisher.newChildActionPublisherForMethod(componentOrMethodName);
};

export default useMetricsPublisher;
